import { getSelectionTitleOutrightProps, isSelectionNotFixture } from "../../selection";
export const getBetTitleSingleBetProps = (bet, selection, state) => {
    if (isSelectionNotFixture(selection)) {
        return getSelectionTitleOutrightProps(bet, selection, state);
    }
    return {
        name: selection.selectionDisplayName,
        odds: bet.displayOdds
    };
};
//# sourceMappingURL=getBetTitleSingleBetProps.js.map